import { Loader2 } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { ErrorState } from '../../components/ui/state';
import { copy } from '../../shared/i18n';
import { completeSignIn } from './cognito';
import { useAuth } from './AuthProvider';

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const exchangeStarted = useRef(false);

  useEffect(() => {
    if (exchangeStarted.current) return;
    exchangeStarted.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const oauthError = params.get('error_description') ?? params.get('error');

    if (oauthError) {
      setError(oauthError);
      return;
    }

    if (!code || !state) {
      setError(copy.auth.missingDetails);
      return;
    }

    void completeSignIn(code, state)
      .then((session) => {
        setSession(session);
        navigate('/admin/dashboard', { replace: true });
      })
      .catch((err: unknown) => setError(err instanceof Error ? err.message : copy.auth.failed));
  }, [navigate, setSession]);

  if (error) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-[#f8faf6] p-4">
        <div className="w-full max-w-md">
          <ErrorState message={error} />
        </div>
      </main>
    );
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f8faf6] p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{copy.auth.signingIn}</CardTitle>
        </CardHeader>
        <CardContent className="flex items-center gap-2 text-sm text-[#5f6b58]">
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          {copy.auth.finishingSignIn}
        </CardContent>
      </Card>
    </main>
  );
}
